import { addDays } from "date-fns";

export const CORE_FIELDS = [
  "opportunity_name",
  "opportunity_deal_size",
  "opportunity_stage",
  "opportunity_close_date",
  "opportunity_account",
];

export const EXCLUDABLE_FIELDS = [
  "opportunity_creation_date",
  "opportunity_probability",
];

export const SELECT_INPUT_FOCUS_DELAY = 100;

export const DEFAULT_DATE_RANGE_PRESET = [
  { label: "Today", value: new Date() },
  { label: "Tomorrow", value: addDays(new Date(), 1) },
  { label: "In 1 week", value: addDays(new Date(), 7) },
  { label: "In 2 weeks", value: addDays(new Date(), 14) },
  { label: "In 45 days", value: addDays(new Date(), 45) },
];
